import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayrateOverrideContainerComponent } from './payrate-override-container/payrate-override-container.component';
import { PayrateOverrideComponent } from './payrate-override/payrate-override.component';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { PayrateOverrideRoute } from './payrate-override.route';
import { PayrateOverrideDataService } from '../data-services/payrate-override/payrate-override.data-service';

@NgModule({
    declarations: [PayrateOverrideContainerComponent, PayrateOverrideComponent],
    providers: [PayrateOverrideDataService],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({ states: [PayrateOverrideRoute] })
    ]
})
export class PayrateOverrideModule {
    constructor() {}
}
